export const registerValidation = (errors, name) => {
  return {
    error: !!errors?.[name],
    helperText: errors?.[name]?.message,
  };
};

export const isEnglish = (value) => {
  const englishRegex = /^[a-zA-Z0-9($#@!*&.+%)]*$/;

  return englishRegex.test(value);
};

export const atLeastOneUppercase = (value) => {
  const uppercaseLetter = /(.*[A-Z].*)/;

  return uppercaseLetter.test(value);
};

export const min = (length, value) => {
  return value.length >= length;
};

export const atLeastOneSymbol = (value) => {
  const symbol = /(.*[($#@!*&.+%)].*)/;

  return symbol.test(value);
};

export const atLeastOneDigit = (value) => {
  const digit = /(.*[0-9].*)/;

  return digit.test(value);
};
